// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-point-presenter[data-v-3344fa4f]{margin-top:20px;margin-bottom:20px}.total-point[data-v-3344fa4f]{font-size:20px;font-weight:700;text-align:center;margin-bottom:20px}.point-list[data-v-3344fa4f]{margin:auto;max-width:400px}", ""]);
// Exports
module.exports = exports;
